import { render, staticRenderFns } from "./addBrandSpecialityData.vue?vue&type=template&id=0a28a83e"
import script from "./addBrandSpecialityData.vue?vue&type=script&lang=js"
export * from "./addBrandSpecialityData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports